import DeliveredServiceContainer from "./DeliveredService.container";

export default DeliveredServiceContainer;
